module.exports = __webpack_public_path__ + "img/section_5.e7b8cc4f.png";